import React, { Component } from "react";
import { connect } from "react-redux";
import $ from 'jquery';
import initFitnessJS from "../../streaming/FitnessController";
import Language from '../../services/contentData';
import Util from "../../streaming/Util";
import classnames from "classnames";
import whiteboard from "../../utils/whiteboardNew";
import InstructorTutorial from "./InstructorTutorial";
import axios from "axios";
import InstructorToolTip from "./InstructorToolTip";
import SessionDataStore from "../../streaming/SessionDataStoreController";
import Const from "../../constants/Constants";
import audioPlay from "../../utils/audioPlay";

class HostFitnessScript extends Component {
  
  constructor() {
    super();

    this.state = {
	  userData:'',
	  sessionScript:[],
	  activityStarted: false,
	  scriptPaused: false,
	  sliderWidth: '100px',
	  currentAct: [],
	  currentActNum: 0,
	  currentActNumWithoutPause: 0,
	  currentActivityDuration: 0,
	  isPausedActivity: false,
	  repsScriptActive: false,
	  repsCurrentActiveNum: 0,
	  timeInSecLeft: 0,
	  repsLeftAfterPause: 0,
	  manualAutomaticScript: 0,
	  forceHidePlaylist: false,
	  pauseActivityOnStart: false,
	  sep: '~@$',
	  scriptEnded: false,
	  fmClientId: 0,
	  fmPlacementId: 0,
	  toolTipText: '',
	  toolTipMsg: 0,
	  D2CSliderWidth: '100px',
	  oneD2CActWidth: '100px',
	  minsD2C: 0,
	  secD2C: 0,
	  secD2CReps: 0,
	  isPlayingFm: false,
	  volumeFM: 50,
	  currentUserData: JSON.parse(localStorage.getItem('userData')),
	  stopPauseVirtual: false,
	  workoutSoundStart: "",
	  workoutSoundEnd: "",
    };
	
	window['sendSyncWhenPartJoin'] = this.sendSyncWhenPartJoin;
	window['startVirtualClass'] = this.startVirtualClass;
	window['previousPause'] = false;
	window['showVolume'] = this.showVolume;
	this.playerFunctions = window['playerFunctions'];
	window['pauseFitnessScript'] = this.pauseFitnessScript;
	window['stopFitnessScript'] = this.stopFitnessScript;
	window.scriptPaused = false;
	this.sessionDataStore = SessionDataStore.getInstance();
	this.soundPlay = new audioPlay();
	this.activityWaitTimeout = 0;
	this.lastFMCheck = 0;
	
	this.rememberTimer = 0;
  }

  componentWillMount = () => {
		let localstoragedata = JSON.parse(localStorage.getItem('userData'));
		this.setState({userData: localstoragedata, sessionScript: localstoragedata.sessionData.scriptDetail},()=>{
		let scriptLength = this.state.sessionScript.length;
		
		if ( window['HostMainInterval'] ) { clearInterval(window['HostMainInterval']); } 

		let visibleWidth = window.$Any('.holdAllActs').width();
		let oneActWidth = 0;
		if ( scriptLength > 2 )
			{
				oneActWidth = visibleWidth / 3;
			}
		else if ( scriptLength > 1 )
			{
				oneActWidth = visibleWidth / 2;
			}
		else 
			{
				oneActWidth = visibleWidth;
			}
		
		let D2CvisibleWidth = window.$Any('.scrollMainHolderD2C').width();
		let D2COneActWidth = 0;
		D2COneActWidth = D2CvisibleWidth / 2;
		let D2Cwidth = scriptLength * D2COneActWidth;
		D2Cwidth = D2Cwidth + 100;
		let widthNum = scriptLength * oneActWidth;
		widthNum = widthNum + 100;		
		this.setState({
				sliderWidth: widthNum,
				manualAutomaticScript: this.state.userData.sessionData.manualAutomaticScript,
				D2CSliderWidth: D2Cwidth,
				oneD2CActWidth: D2COneActWidth,
			});
	  });
	  
	  if ( window['HostMainInterval'] ) { clearInterval(window['HostMainInterval']); } 
	  
	  window['currentActNum'] = this.state.currentActNum;
	  window['timeLefSec'] = this.state.timeInSecLeft;
	  
		var activitiesArray = localstoragedata.sessionData.scriptDetail;
		var isFountFm = false;
		if ( activitiesArray.length > 0 )
			{
				for ( var i = 0; i < activitiesArray.length; i++ )
					{
						var object = activitiesArray[i];
						if ( !isFountFm )
							{
								if ( object.attribute && object.attribute[10] && object.attribute[10].attrValue != null && object.attribute[10].attrValue != '' )
									{
										isFountFm = true;
									}
							}
					}
			}
			
		if ( localstoragedata.sessionData.workoutSoundStart && localstoragedata.sessionData.workoutSoundStart !== "" )
			{
				this.setState({workoutSoundStart: localstoragedata.sessionData.workoutSoundStart});
			}
			
		if ( localstoragedata.sessionData.workoutSoundEnd && localstoragedata.sessionData.workoutSoundEnd !== "" )
			{
				this.setState({workoutSoundEnd: localstoragedata.sessionData.workoutSoundEnd});
			}
  }

  componentDidMount = () => {
    var loadScript = function (src) {
      var tag = document.createElement('script');
      tag.async = false;
      tag.src = src;
      
      var body = document.getElementsByTagName('body')[0];
      body.appendChild(tag);
    }

    initFitnessJS();
    window.$Any('[data-toggle="tooltip"]').tooltip();
	
	if ( localStorage.getItem('forceHidePlaylist') )
		{
			this.setState({ forceHidePlaylist: true});
		}
		window['setFmVolumeFromRtm']=(volume)=>{
	         this.setState({volumeFM: volume});
	         this.playerFunctions.changeVolume(volume);
		};
  }
	
  
fitnessScriptStart = () =>{
	var sessionDataStorage = JSON.parse(localStorage.getItem('userData')).sessionData;
	if ( ( sessionDataStorage.StartRecordSession == 1 && window.$Any('#record_text').text() !== 'Stop Recording' ) || ( this.props.state.multi_window_status && window.$Any('#record_text').text() !== 'Stop Recording' ) ) 
		{
			window.$Any('#record_session').trigger('click');
		}
		
	$('#startWork').addClass('d-none');
	this.props.updateStateFromChild({showStartScriptBtn: false});
	window['script_is_started'] = true;
	window['usingPose'] = true;
	
    let sessionData = this.state.userData.sessionData;
	let sessionScriptDetails = localStorage.getItem('scriptDetailsObject');
	let currentNum = 0;
	let currentNumWithoutPause = 0;
	let sendSync = false;
	if ( sessionScriptDetails )
		{
			let scriptDetail = JSON.parse(sessionScriptDetails);
			
			if (scriptDetail.sessionId == sessionData.id )
				{
					let localstoragedata = JSON.parse(localStorage.getItem('userData'));
					
					currentNum = scriptDetail.scriptIndex;
					sendSync = true;
					var activityId = localstoragedata.sessionData.scriptDetail[scriptDetail.scriptIndex]['id'];
					var activityArray = localstoragedata.sessionData.scriptDetail;
					
					for ( let i = 0; i < activityArray.length; i++ )
						{
							if ( activityArray[i]['attribute'][0]['attrValue'] == 'Pause' || activityArray[i]['attribute'][0]['attrValue'] == 'Pause Virtual' )
								{
									activityArray.splice(i, 1);
									i--;
								}
						}
					
					for ( let b = 0; b < activityArray.length; b++ )
						{
							if ( activityArray[b]['id'] == activityId )
								{
									currentNumWithoutPause = b;
									this.setState({currentActNumWithoutPause: currentNumWithoutPause});
								}
						}
					
					this.markActivityAsDone(true);
				}
			else 
				{
					currentNum = this.state.currentActNum;
				}				
			
			
		}
	else 
		{
			currentNum = this.state.currentActNum;
		}		
	
	let firstActivity = this.state.sessionScript[currentNum];
	currentNum = currentNum + 1;
	
	let addObject = {"sessionId": this.state.currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": this.state.currentUserData.id, "toFromId": "all", "message": 211, "details": JSON.stringify({"action":"started", "type":"script", "name": firstActivity.name, "scriptIndex": 1}), "timestamp": Util.getCurrentTimestamp()};
	this.sessionDataStore.addSessionData(addObject);

	if ( !this.props.state.multi_window_status )
		{
			let divWidth = window.$Any('.upNextActivityHolder').width();
			var moveLeft = parseInt(divWidth) * parseInt(currentNum);
			window.$Any('.hold_script').css({'left': '-'+moveLeft+"px"});
		}
	else 
		{
			let divWidth = this.state.oneD2CActWidth;
			var moveLeft = parseInt(divWidth) * ( currentNum - 1 );
			window.$Any('.scriptScrollHolderD2C').css({'left': '-'+moveLeft+"px"});
		}
		
	currentNumWithoutPause = currentNumWithoutPause + 1;
	if ( firstActivity['attribute'][0]['attrValue'] != 'Pause' && firstActivity['attribute'][0]['attrValue'] != 'Pause Virtual' ) { this.setState({currentActNumWithoutPause: currentNumWithoutPause}); }

	window.startHostFitnessScript();
	
	let firstActivityDuration = parseInt(firstActivity['attribute'][2]['attrValue']);
	//window.hostSyncScriptFunction(1, currentNum, firstActivityDuration, 0);
	let timerForNextActivity = 0;
	var timerCount = '';
	if ( firstActivity['attribute'][1]['attrValue'] == 'Time' )
		{
			timerForNextActivity = firstActivity['attribute'][2]['attrValue'];
			timerCount = this.getTimerFormat(timerForNextActivity);	
			this.setState({
				currentActivityDuration: timerCount,
				timeInSecLeft: timerForNextActivity,
			},()=>{
				window['timeLefSec'] = this.state.timeInSecLeft;
			})
		}
	else 
		{
			this.setState({
				currentActivityDuration: firstActivity['attribute'][2]['attrValue'],
				timeInSecLeft: timerForNextActivity,
			}, () => {window['timeLefSec'] = this.state.timeInSecLeft;})
		}
	
	if ( window['deviceNotSupported'+this.state.currentUserData.id] && ( firstActivity['attribute'][0]['attrValue'] == 'Virtual Equipment' || firstActivity['attribute'][0]['attrValue'] == 'Virtual Assistant' || firstActivity['attribute'][0]['attrValue'] == 'Pause Virtual' ) )
		{
			window.$Any('#virtualmsg').removeClass('d-none').text('Virtual Activity Not Supported on this Device');
		}
	
	if ( !window['deviceNotSupported'+this.state.currentUserData.id] && ( firstActivity['attribute'][0]['attrValue'] == 'Virtual Equipment' || firstActivity['attribute'][0]['attrValue'] == 'Virtual Assistant' ) )
		{
			this.addVirtualEquipment(firstActivity, false, false);
		}
	else if ( !window['deviceNotSupported'+this.state.currentUserData.id] && ( firstActivity['attribute'][0]['attrValue'] == 'Pause' || firstActivity['attribute'][0]['attrValue'] == 'Pause Virtual' ) )
		{
			let nextActivity = this.state.sessionScript[currentNum];
			if ( nextActivity ) 
				{
					if ( nextActivity['attribute'][0]['attrValue'] == 'Pause' || nextActivity['attribute'][0]['attrValue'] == 'Pause Virtual' )
						{
							nextActivity = this.state.sessionScript[currentNum+1];
						}
					
					if ( nextActivity && (nextActivity['attribute'][0]['attrValue'] == 'Virtual Equipment' || nextActivity['attribute'][0]['attrValue'] == 'Virtual Assistant') )
						{
							this.addVirtualEquipment(nextActivity, firstActivity, false);
						}
				}				
		}
	else if ( !window['deviceNotSupported'+this.state.currentUserData.id] && ( firstActivity['attribute'][0]['attrValue'] != 'Pause' && firstActivity['attribute'][0]['attrValue'] != 'Pause Virtual' ) )
		{
			this.checkRoomSetup();
		}
		
	this.notifyActivityChange(false, currentNum)
	this.setState({
		activityStarted: true,
		currentAct: firstActivity,
		currentActNum: currentNum,
	}, () => {
		this.checkIfInjected();
		window.$Any('#mainDurationSvg').attr({'style': '--progress-bar-width:6px;--progress-color:#121126;--progress-percent: 0;'});
		this.currentActivityDurationNum();
		window['currentActNum'] = this.state.currentActNum;
		window['currentActivity'] = this.state.currentAct;
		window['activityStarted'] = this.state.activityStarted;

		let state = 1;
		let currentActNum = this.state.currentActNum;
		let currentActivity = this.state.currentAct;
		let currentActivityDuration = 0;
			
		if (!this.state.repsScriptActive)
			{
					currentActivityDuration = parseInt(currentActivity['attribute'][2]['attrValue']);
			}
				
		else 
			{
					currentActivityDuration = parseInt(currentActivity.attribute[3].attrValue) * parseInt(currentActivity.attribute[9].attrValue);
			}	
			
		if ( this.state.pauseActivityOnStart ) { state = 2; }
			
		let timeLeft = this.state.timeInSecLeft;
		let timeSpent = currentActivityDuration - timeLeft;
		
		if ( sendSync )
			{
				window.hostSyncScriptFunction(state, currentNum, currentActivityDuration, 0);
			}
		
		var fmActivity = currentActivity;
		var previousFMActivity = this.findLastFeedFMActivity(currentActNum);
		if ( previousFMActivity != '' && !this.playerFunctions.isPlayedAudio ) { fmActivity = previousFMActivity; }
		
		if ( fmActivity.attribute && fmActivity.attribute[10] && fmActivity.attribute[10].attrValue != null && fmActivity.attribute[10].attrValue != '' )
			{
				if ( !this.state.pauseActivityOnStart )
					{
						var id = parseInt(fmActivity.attribute[10].attrValue);
						if ( window['preClassFeedfmId'] && parseInt(window['preClassFeedfmId']) != id )
							{
								if ( id > 0 ) 
									{ 
										this.playPlayer(fmActivity.attribute[10].attrValue, fmActivity.attribute[11].attrValue); 
									}
								else 
									{ 
										this.stopPlayer(); 
									}
								
							}
						else if ( window['preClassFeedfmId'] == '' )
							{
								if ( id > 0 ) 
									{ 
										this.playPlayer(fmActivity.attribute[10].attrValue, fmActivity.attribute[11].attrValue); 
									}
								else 
									{ 
										this.stopPlayer(); 
									}
							}							
						
					}
			}
		
	});
	
	if ( sessionDataStorage.StartMusicSession == 1 &&sessionDataStorage.playlist_id !== 'null' && !this.state.forceHidePlaylist && window.$Any('#playlist_play').is(":visible") ) 
		{
			window.$Any('#playlist_play').trigger('click');
		}
}

findLastFeedFMActivity=(actIndex)=> {
	var previousFMActivity = '';
	for ( var i = 0; i < actIndex; i++ )
		{
			var scriptAct = this.state.sessionScript[i];
			if ( scriptAct && scriptAct.attribute && scriptAct.attribute[10] && scriptAct.attribute[10].attrValue != null && scriptAct.attribute[10].attrValue != '' )
				{
					previousFMActivity = this.state.sessionScript[i];
					//console.log('found feedFm activity', previousFMActivity);
				}
		}
	
	return previousFMActivity;
}

getTimerFormat=(duration)=>{
		// Hours, minutes and seconds
		var hrs = ~~(duration / 3600);
		var mins = ~~((duration % 3600) / 60);
		var secs = ~~duration % 60;

		// Output like "1:01" or "4:03:59" or "123:03:59"
		var ret = "";

		if (hrs > 0) {
			ret += "" + hrs + ":" + (mins < 10 ? "" : "");
		}
		
		if ( mins.toString().length == 1 && !this.props.state.multi_window_status ) 
			{ 
				mins = '0'+mins; 
			}
		
		if ( this.props.state.multi_window_status )
			{
				var secTimer = secs;
				if ( secs.toString().length == 1 )
					{
						secTimer = secs;
						secs = '0'+secs;
					}
				
				
				if ( this.state.workoutSoundEnd == "3, 2, 1 - No sound" )
					{
						if ( mins < 1 && secs < 4 )
							{
								if ( this.props && this.props.updateStateFromScript )
									{
										this.props.updateStateFromScript({showBigClock: true, counterSec: secTimer});
									}
							}					
						else 
							{
								if ( this.props && this.props.updateStateFromScript )
									{
										this.props.updateStateFromScript({showBigClock: false});
									}
							}
					}
				
					
				this.setState({
					minsD2C: mins,
					secD2C: secs,
					secD2CReps: duration,
				});
			}
		
		ret += "" + mins + ":" + (secs < 10 ? "0" : "");
		ret += "" + secs;
		return ret;
	}
	
getInactiveSec=(duration)=>{
	var mins = ~~((duration % 3600) / 60);
	var secs = ~~duration % 60;
	
	if ( secs.toString().length == 1 )
		{
			secs = '0'+secs;
		}
	
	return secs;
}

getInactiveMin=(duration)=>{
	var mins = ~~((duration % 3600) / 60);
	return mins;
}	

getInactiveSecReps=(currentActivity)=>{
	var currentActivityDuration = parseInt(currentActivity.attribute[3].attrValue) * parseInt(currentActivity.attribute[9].attrValue);
	if ( currentActivityDuration.toString().length == 1 )
		{
			currentActivityDuration = '0'+currentActivityDuration;
		}
		
	return currentActivityDuration;
}

playWorkoutSounds=(type)=>{
	var sound = type == "start" ? this.state.workoutSoundStart : this.state.workoutSoundEnd;
	var param = "";
	if ( sound !== "" && sound !== "3, 2, 1 - No sound" )
		{
			if ( sound == "Bell sound" ) { param = "bell"; }
			if ( sound == "Ding" ) { param = "ding"; }
			if ( sound == "Go" ) { param = "go"; }
			if ( sound == "3, 2, 1" ) { param = "count321"; }
			if ( sound == "All done" ) { param = "allDone"; }
				
			if ( param !==  "" ) 
				{ 
					this.soundPlay.stopAudio();	
					this.soundPlay.playAudio(param); 
				}
		}
}
	
currentActivityDurationNum =(timeRemaining, virtualActivity)=>{
	console.log('currentActivityDurationNum currentAct', this.state.currentAct);
	let currentActivity = this.state.currentAct;
	var isRunningScript = false;
	
	var rememberRepeat = 0;
	let currentActivityDuration = 0;
	var mainInterval;
	var timerCount = this.state.currentActivityDuration;	
	var video;
	var wasActivityPaused = this.state.scriptPaused;
	let mainthis = this;
	var getDurationNum= currentActivity['attribute'][2]['attrValue'];
	let nextActivity = this.state.sessionScript[this.state.currentActNum];
	if ( virtualActivity )
		{
			let currentNum = this.state.currentActNum;
			let currentActivity = this.state.sessionScript[currentNum];
			let previousNumber = currentNum - 2;
			if ( previousNumber < 0 ) { previousNumber = 0; }
			let previousActivity = this.state.sessionScript[previousNumber];
			
			var timeoutTimeAct = 2000;
			
			if ( previousActivity && ( previousActivity['attribute'][0]['attrValue'] == 'Pause' || previousActivity['attribute'][0]['attrValue'] == 'Pause Virtual' ) )
				{
					timeoutTimeAct = 500;
				}
			
			setTimeout(function() {
				mainthis.currentActivityDurationNum(timeRemaining);
				
				var fmActivity = mainthis.state.currentAct;
				var previousFMActivity = mainthis.findLastFeedFMActivity(currentNum);
				if ( previousFMActivity != '' && !mainthis.playerFunctions.isPlayedAudio ) { fmActivity = previousFMActivity; }
				
				var id = parseInt(fmActivity.attribute[10]['attrValue']);
				console.log('---PLAYER ID-------', id);
				if ( id > 0 ) 
					{ 
						mainthis.playPlayer(fmActivity.attribute[10]['attrValue'], fmActivity.attribute[11].attrValue); 
					}
			}, timeoutTimeAct);
			
			return;
		}
		
	var activityType = currentActivity['attribute'][0]['attrValue'];
	
	if ( currentActivity['attribute'][1]['attrValue'] == 'Time' )
		{
			currentActivityDuration = currentActivity['attribute'][2]['attrValue'];
			var timer = parseInt(currentActivityDuration);
			if ( timeRemaining ) 
				{
					timer = timeRemaining;
					getDurationNum = timeRemaining;
				}
				
			if ( this.state.isPausedActivity ) 
				{
					
					timer = this.rememberTimer; 
					this.setState({
						isPausedActivity: false,
					});
				}
				
			this.setState({
				timeInSecLeft: timer
			});
			
			if ( timer == currentActivityDuration && activityType !== "Pause Virtual" && activityType !== "Pause" && activityType !== "Virtual Equipment" && !window['clickedOnLeave'] )
				{
					this.playWorkoutSounds("start");
				}
			
			
			window['utcTimeInstrucotr'] = Util.getUTCTimestamp();
			window['timerRemainingInstructor'] = parseInt(timer);	
				
			if ( window['HostMainInterval'] ) { clearInterval(window['HostMainInterval']); } 
			window['HostMainInterval'] = setInterval(function(){
				if ( mainthis.state.pauseActivityOnStart || mainthis.state.stopPauseVirtual )
					{
						timerCount = mainthis.getTimerFormat(timer);
						mainthis.setState({
							currentActivityDuration: timerCount,
							timeInSecLeft: timer,
						}, ()=>{window['timeLefSec'] = mainthis.state.timeInSecLeft;});
						
						//mainthis.pauseFitnessScript();
						mainthis.setState({pauseActivityOnStart: false});
						
						var allDoneRoomSetup = true;
						
						if ( !mainthis.state.stopPauseVirtual )
							{
								window.$Any('.participantStreamPart').each(function(item, index){
									let parIdMain = window.$Any(this).attr('id').split('participant_agora');
									let parId = parseInt(parIdMain[1]);
									  if ( parId != mainthis.state.userData.id )
										{
											window['startDrawing'](false, parId);
											
											if ( !window['userWhiteboard'][parId] || ( window['userWhiteboard'][parId] && !window['userWhiteboard'][parId].roomSetup.workoutAreaSetupDone ) )
												{
													//allDoneRoomSetup = false;
												}
										}
								 });
							}
						
						if ( window['userWhiteboard'][mainthis.state.userData.id] && !window['userWhiteboard'][mainthis.state.userData.id].roomSetup.workoutAreaSetupDone )
							{
								allDoneRoomSetup = false;
							}
						
						if ( !mainthis.state.stopPauseVirtual )
							{
								var text = 'pauseActivityOnStart' + mainthis.state.sep + parseInt(mainthis.state.currentActNum-1) + mainthis.state.sep + window['previousPause'];
								//window['sendMessageToChannel'](text);
							
								if ( currentActivity['attribute'][0]['attrValue'] == 'Virtual Equipment' && allDoneRoomSetup && mainthis.state.userData.sessionData.manualAutomaticScript == 1 && !window['clickedOnLeave'] )
									{
										//window['startVirtualClass'](currentActivityDuration);
										mainthis.playWorkoutSounds("start");
									}
							}
						else if ( window['userWhiteboard'][mainthis.state.userData.id].roomSetup.workoutAreaSetupDone )
							{
								//window['startVirtualClass'](currentActivityDuration, true);
							}
						mainthis.setState({stopPauseVirtual: false});
						
						mainthis.currentActivityDurationNum(timeRemaining, true);
						
						if ( window['userWhiteboard'][mainthis.state.userData.id] )
							{
								window['userWhiteboard'][mainthis.state.userData.id].doActivityEvents('activityStarting');
								
								if ( window.mediaPipeRoomSetupFail )
									{
										window.mediaPipeLastTry = true;
									}
							}
						
						if ( window['HostMainInterval'] )
							{
								clearInterval(window['HostMainInterval']);
							}
						
						return;
					}
				
				timer--;
				
				if ( window['utcTimeInstrucotr'] && window['timerRemainingInstructor'] ) 
						{
							//getDurationNum = parseInt(getDurationNum);
							timer = window['timerRemainingInstructor'] - (Util.getUTCTimestamp() - window['utcTimeInstrucotr']);
						}
							
				if ( timer == 3 && activityType != "Pause Virtual" && activityType != "Pause" && mainthis.state.workoutSoundEnd == "3, 2, 1" && !window['clickedOnLeave'] )
					{
						mainthis.playWorkoutSounds("end");
					}
				
				if ( timer == 1 && activityType != "Pause Virtual" && activityType != "Pause" && mainthis.state.workoutSoundEnd !== "3, 2, 1" && !window['clickedOnLeave'] )
					{
						mainthis.playWorkoutSounds("end");
					}						
				
				if ( timer > 0 )
					{
						window.$Any('#mainDurationSvg').removeClass('d-none');
						timerCount = mainthis.getTimerFormat(timer); 
						
						if ( !mainthis.playerFunctions.isPlayedAudio && mainthis.lastFMCheck < ((new Date()).getTime()-10000) && !window.leaveBtnPressed )
							{
								mainthis.lastFMCheck = new Date().getTime();
								console.log('check FM', mainthis.lastFMCheck);
								var fmActivity = mainthis.state.currentAct;
								var previousFMActivity = mainthis.findLastFeedFMActivity(mainthis.state.currentActNum);
								if ( previousFMActivity != '' ) { fmActivity = previousFMActivity; }
								
								var id = parseInt(fmActivity.attribute[10]['attrValue']);
								console.log('---PLAYER ID-------', id);
								if ( id > 0 ) 
									{ 
										mainthis.playPlayer(fmActivity.attribute[10]['attrValue'], fmActivity.attribute[11].attrValue); 
									}
							}
						
						mainthis.setState({
							currentActivityDuration: timerCount,
							timeInSecLeft: timer,
						}, ()=>{
								window['timeLefSec'] = mainthis.state.timeInSecLeft;
								});
						mainthis.setPercent(currentActivity.attribute[2].attrValue, timer);
					}
				else
					{

						timerCount = '00:00';
						mainthis.notifyActivityChange(true)
						window.$Any('#mainDurationSvg').attr({'style': '--progress-bar-width:6px;--progress-color:#121126;--progress-percent: 100;'}); 
						mainthis.setState({
							currentActivityDuration: timerCount,
							timeInSecLeft: 1,
						}, () => {window['timeLefSec'] = mainthis.state.timeInSecLeft;});
						if (mainthis.state.sessionScript.length ==  mainthis.state.currentActNum)
							{
								mainthis.setState({
									currentActivityDuration: timerCount,
									timeInSecLeft: 0,
								}, ()=>{window['timeLefSec'] = mainthis.state.timeInSecLeft;});
							}
						clearInterval(window['HostMainInterval']);
						isRunningScript = false;
						window['insertStoredRTM']();
						if ( mainthis.state.sessionScript.length >  mainthis.state.currentActNum )
							{
								let timeOutTime = 1000;
								
								if ( mainthis.props.state.multi_window_status )
									{
										timeOutTime = 1;
									}
								
								window['lastSecTimeOut'] = setTimeout(() => {
									
									if ( mainthis.state.manualAutomaticScript == 0 )
										{
											if ( currentActivity.attribute[4] && currentActivity.attribute[4].attrValue != '' )
												{
													mainthis.clearInjectedVideo();
												}
											
											mainthis.setState({
												scriptPaused: true,
												timeInSecLeft: 0,
											}, ()=>{
													window['scriptPaused'] = mainthis.state.scriptPaused;
													if ( this.props && this.props.updateStateFromScript )
														{
															this.props.updateStateFromScript({scriptPaused: mainthis.state.scriptPaused, showBigClock: false});
														}
													});
											mainthis.markActivityAsDone();	
										}
									
									if ( !mainthis.state.scriptPaused && mainthis.state.manualAutomaticScript != 0 )
										{
											let activityWaitTime = mainthis.state.currentUserData.default.waitTimeAfterRegular;
											if ( currentActivity['attribute'][0]['attrValue'] == 'Virtual Equipment' )
												{
													activityWaitTime = mainthis.state.currentUserData.default.waitTimeAfterVirtual;
												}
											
											if ( currentActivity['attribute'][0]['attrValue'] == 'Pause Virtual' || currentActivity['attribute'][0]['attrValue'] == 'Pause' )
												{
													activityWaitTime = 0;
												}
											
											timerCount = mainthis.getTimerFormat(0); 
											if ( mainthis.props && mainthis.props.updateStateFromScript )
												{
													mainthis.props.updateStateFromScript({showBigClock: false});
												}
											mainthis.setState({
												currentActivityDuration: timerCount,
												timeInSecLeft: 0,
											}, ()=>{window['timeLefSec'] = mainthis.state.timeInSecLeft;});
											
											mainthis.activityWaitTimeout = setTimeout(function(){
												mainthis.startNextScript();
											}, activityWaitTime);
										}
								},timeOutTime);
							}
							
						else 
							{
								let timeOutTime = 1000;
								
								if ( mainthis.props.state.multi_window_status )
									{
										timeOutTime = 1;
									}
									
								setTimeout(() => {
									mainthis.stopScriptAtEnd();
								},timeOutTime);
								
							}	
					}
					
				
			}, 1000);
			
			mainthis.rememberTimer = timer;	
			
		}
		
	if ( currentActivity.attribute[1] && currentActivity.attribute[1].attrValue === 'Reps' )
		{
			this.setState({
				repsScriptActive: true,
			}, ()=>{window['repsScriptActive'] = this.state.repsScriptActive});
			
			isRunningScript = true;
			var repeatNum = parseInt(currentActivity.attribute[3].attrValue);
			var repeatSeconds = parseInt(currentActivity.attribute[9].attrValue);
			var fullSecondsRepeat = repeatNum * repeatSeconds;
			timer = repeatNum * repeatSeconds;
			
			if ( this.state.isPausedActivity ) 
				{ 
					timer = this.rememberTimer;
					this.setState({
						isPausedActivity: false,
					})
					 
				}
			if ( timeRemaining ) 
				{ 
					timer = timeRemaining; 
				}
			
			timerCount = this.getTimerFormat(timer);	
			
			this.setState({
				timeInSecLeft: timer
			});
			
			let mainthis = this;
			window['HostMainInterval'] = setInterval(function(){
				timer--;
				var repeatNumberCurrent = parseInt(currentActivity.attribute[3].attrValue) -  Math.floor(timer /  parseInt(currentActivity.attribute[9].attrValue));
				
				var repeatNumberLeft = (repeatNum - repeatNumberCurrent) + 1;
				
				if ( timer > 0 )
					{
						window.$Any('#mainDurationSvg').removeClass('d-none');
						timerCount = mainthis.getTimerFormat(timer);
						mainthis.setState({
							currentActivityDuration: timerCount,
							repsCurrentActiveNum: repeatNumberLeft,
							timeInSecLeft: timer,
							repsLeftAfterPause: repeatNumberLeft,
						}, ()=>{window['timeLefSec'] = mainthis.state.timeInSecLeft;});
						mainthis.setPercent(fullSecondsRepeat, timer);
																		
					}
				else 
					{
						timerCount = '00:00';
						mainthis.notifyActivityChange(true)
						window.$Any('#mainDurationSvg').attr({'style': '--progress-bar-width:6px;--progress-color:#121126;--progress-percent: 100;'}); 
						mainthis.setState({
							repsCurrentActiveNum: repeatNum,
							currentActivityDuration: timerCount,
							timeInSecLeft: 1,
							repsLeftAfterPause: 0,
						}, ()=>{window['timeLefSec'] = mainthis.state.timeInSecLeft;});
						clearInterval(window['HostMainInterval']);
						isRunningScript = false;
						mainthis.setState({
						repsScriptActive: false,
						}, ()=>{window['repsScriptActive'] = mainthis.state.repsScriptActive});
						
						if ( mainthis.state.sessionScript.length >  mainthis.state.currentActNum )
							{
								let timeOutTime = 1000;
								if ( mainthis.props.state.multi_window_status )
									{
										timeOutTime = 1;
									}
								window['lastSecTimeOut'] = setTimeout(() => {
									if ( mainthis.state.manualAutomaticScript == 0 )
										{
											if ( currentActivity.attribute[4] && currentActivity.attribute[4].attrValue != '' )
												{
													mainthis.clearInjectedVideo();
												}
												
											mainthis.setState({
												scriptPaused: true,
												timeInSecLeft: 0,
											}, ()=>{
												window['scriptPaused'] = mainthis.state.scriptPaused; 
												if ( this.props && this.props.updateStateFromScript )
													{
														this.props.updateStateFromScript({scriptPaused: mainthis.state.scriptPaused, showBigClock: false});
													}
												});
											mainthis.markActivityAsDone();
										}
									if ( !mainthis.state.scriptPaused && mainthis.state.manualAutomaticScript != 0 )
										{
											mainthis.startNextScript();
										}
								},timeOutTime);
							}
						else 
							{
								let timeOutTime = 1000;
								if ( mainthis.props.state.multi_window_status )
									{
										timeOutTime = 1;
									}
								setTimeout(() => {
									mainthis.stopScriptAtEnd();
								},timeOutTime);
							}							
					}					
				
			}, 1000);
		}		
}   

markActivityAsDone =(mod)=>{
	var activityArray = this.state.sessionScript;
	let currentNum = this.state.currentActNum;
	let indexNum = 0; 
	if ( mod )
		{
			let sessionScriptDetails = localStorage.getItem('scriptDetailsObject');
			let scriptDetail = JSON.parse(sessionScriptDetails);
			var doneActivitesNum = scriptDetail.scriptIndex;
			indexNum = doneActivitesNum;
		}
	else 
		{
			indexNum = currentNum;
		}
		
	currentNum = currentNum + 1;
	window.$Any('.one_activity_menu').removeClass('active');
	
	for ( let i = 0; i < activityArray.length; i++ )
		{
			if ( i < indexNum )
				{
					window.$Any('#workout'+activityArray[i].id).addClass('active');
				}
		}
}
 
startNextScript = () =>{
	this.setState({
			scriptPaused: false
		},()=>{
			if ( this.props && this.props.updateStateFromScript )
				{
					this.props.updateStateFromScript({scriptPaused: this.state.scriptPaused});
				}
			});
	window.scriptPaused = false;
	$('#startWork').addClass('d-none');
	window['usingPose'] = true;
	this.props.updateStateFromChild({showStartScriptBtn: false});
	
	window.$Any('#mainDurationSvg').addClass('d-none');
	var activityArray = this.state.sessionScript;
	window.$Any('#mainDurationSvg').attr({'style': '--progress-bar-width:6px;--progress-color:#121126;--progress-percent: 0;'});
	let currentNum = this.state.currentActNum;
	let indexNum = currentNum;
	let currentActivity = this.state.sessionScript[currentNum];
	let previousNumber = currentNum - 1;
	if ( previousNumber < 0 ) { previousNumber = 0; }
	let previousActivity = this.state.sessionScript[previousNumber];
	currentNum = currentNum + 1;
	
	let currentNumWithoutPause = this.state.currentActNumWithoutPause + 1;
	if ( currentActivity['attribute'][0]['attrValue'] != 'Pause' && currentActivity['attribute'][0]['attrValue'] != 'Pause Virtual' ) { this.setState({currentActNumWithoutPause: currentNumWithoutPause}); }
	
	window.$Any('.one_activity_menu').removeClass('active');
	
	let sessionData = this.state.userData.sessionData;
	let scriptDetailsObject = { 'sessionId': 0, 'scriptIndex': 0};
	let sessionId = sessionData.id;
	scriptDetailsObject['sessionId'] = sessionId;
	scriptDetailsObject['scriptIndex'] = indexNum;
	window.activityAlreadyStarted = false;
	
	localStorage.setItem("scriptDetailsObject", JSON.stringify(scriptDetailsObject));
	
	for ( let i = 0; i < activityArray.length; i++ )
		{
			if ( i < indexNum )
				{
					window.$Any('#workout'+activityArray[i].id).addClass('active');
				}
		}
	
	if ( !this.props.state.multi_window_status )
		{
			let divWidth = window.$Any('.upNextActivityHolder').width();
			var moveLeft = parseInt(divWidth) * currentNum;
			window.$Any('.hold_script').css({'left': '-'+moveLeft+"px"});
		}
	else 
		{
			let divWidth = this.state.oneD2CActWidth;
			var moveLeft = parseInt(divWidth) * ( currentNum - 1 );
			window.$Any('.scriptScrollHolderD2C').css({'left': '-'+moveLeft+"px"});
		}		
	
	
	let timerForNextActivity = 0;
	var timerCount = '';
	if ( currentActivity['attribute'][1]['attrValue'] == 'Time' )
		{
			timerForNextActivity = currentActivity['attribute'][2]['attrValue'];
			var timerCount = this.getTimerFormat(timerForNextActivity);	
			this.setState({
				currentActivityDuration: timerCount,
			})
		}
	else 
		{
			timerForNextActivity = currentActivity['attribute'][2]['attrValue'] * currentActivity['attribute'][3]['attrValue']; 
			
		}
	timerCount = this.getTimerFormat(timerForNextActivity);	
	
	if ( window['userWhiteboard'][this.state.currentUserData.id] && window['userWhiteboard'][this.state.currentUserData.id].trackerActions.mediaPipeToggleTimeout )
		{
			clearTimeout(window['userWhiteboard'][this.state.currentUserData.id].trackerActions.mediaPipeToggleTimeout);
			window['userWhiteboard'][this.state.currentUserData.id].clearMessageInstructions();
			if ( window.disableCalculatingAR ) { window.disableCalculatingAR(); }
		}
	
	if ( currentActivity['attribute'][0]['attrValue'] == 'Virtual Equipment' || currentActivity['attribute'][0]['attrValue'] == 'Virtual Assistant' )
		{
			window['previousPause'] = previousActivity['attribute'][0]['attrValue'] == 'Pause' ? true : false;
			if ( !window['deviceNotSupported'+this.state.currentUserData.id] ) { this.addVirtualEquipment(currentActivity, false, window['previousPause']); }
			else
				{
					window.$Any('#virtualmsg').removeClass('d-none').text('Virtual Activity Not Supported on this Device');
				}
		}
	else if ( currentActivity['attribute'][0]['attrValue'] != 'Pause' && currentActivity['attribute'][0]['attrValue'] != 'Pause Virtual' )
		{
			this.checkRoomSetup();
			
			$('#canvasWrap').addClass('d-none');
			window.$Any('#virtualmsg').addClass('d-none').text('');
			window.changeGlobalActType('', parseInt(this.state.userData.id));
			
			if ( previousActivity['attribute'][0]['attrValue'] == 'Virtual Equipment' || previousActivity['attribute'][0]['attrValue'] == 'Virtual Assistant' )
				{
					for ( var i = 0; i < window.$Any('.rep-count').length; i++ )
						{
							if ( !window.$Any('.rep-count')[i].classList.contains('ppm_count') )
								{
									var partId = window.$Any('.rep-count')[i].id.split('repCount')[1];
									var statsObj = {
										'actId': previousActivity['id'],
										'actName': previousActivity['name'],
										'duration': previousActivity['attribute'][2]['attrValue'],
										'reps': window.$Any('#repCount'+partId).html(),
										'rpm': window.$Any('#ppmCount' + partId).find('.counter-number').html()
									};

									if (!window['activityStats'][partId]) {
										window['activityStats'][partId] = {};
									}
									window['activityStats'][partId][previousActivity['id']] = statsObj;
								}
						}
					if (window['canvasOn']) {
						window.$Any('.canvas-close-icon').trigger('click');
						window.$Any('.equipment_stats_hold').addClass('d-none');
						window.$Any('.canvas-trash-icon').removeClass('d-none');
						window.$Any('.canvas-share').removeClass('d-none');
						if ( window.detectionDisabled ) { window.$Any('#virtualmsg').addClass('d-none'); }
					}
				}
		}
	this.notifyActivityChange(false, currentActivity)
	this.setState({
		currentAct: currentActivity,
		currentActNum: currentNum,
		currentActivityDuration: timerCount,
	}, () => {
		this.checkIfInjected();
		this.currentActivityDurationNum();
		
		window.hostRtmForNextScript(this.state.currentActNum, this.state.pauseActivityOnStart);
				
		if ( currentActivity['attribute'][0]['attrValue'] == 'Pause' || currentActivity['attribute'][0]['attrValue'] == 'Pause Virtual' )
			{
				//window.hostRtmForNextScript(this.state.currentActNum, this.state.pauseActivityOnStart, true);

				let nextActivity = this.state.sessionScript[currentNum];
				if ( nextActivity )
					{
				console.log('nextActivity pause', nextActivity);
						if ( nextActivity['attribute'][0]['attrValue'] == 'Pause' || nextActivity['attribute'][0]['attrValue'] == 'Pause Virtual' )
							{
								nextActivity = this.state.sessionScript[currentNum+1];
							}
						
				console.log('nextActivity pause 2', nextActivity);
				
						if ( nextActivity && (nextActivity['attribute'][0]['attrValue'] == 'Virtual Equipment' || nextActivity['attribute'][0]['attrValue'] == 'Virtual Assistant') )
							{
								if ( !window['deviceNotSupported'+this.state.currentUserData.id] ) { this.addVirtualEquipment(nextActivity, currentActivity, false); }
								else
									{
										window.$Any('#virtualmsg').removeClass('d-none').text('Virtual Activity Not Supported on this Device');
									}
							}
						else
							{
								$('#canvasWrap').addClass('d-none');
								window.$Any('#virtualmsg').addClass('d-none').text('');
								window.changeGlobalActType('', parseInt(this.state.userData.id));
								
								if (window['canvasOn']) {
									window.$Any('.canvas-close-icon').trigger('click');
									window.$Any('.equipment_stats_hold').addClass('d-none');
									window.$Any('.canvas-trash-icon').removeClass('d-none');
									window.$Any('.canvas-share').removeClass('d-none');
								}
							}
					}				
			}
		
		window['currentActNum'] = this.state.currentActNum;
		window['currentActivity'] = this.state.currentAct;
		
		var fmActivity = currentActivity;
		var previousFMActivity = this.findLastFeedFMActivity(currentNum);
		if ( previousFMActivity != '' && !this.playerFunctions.isPlayedAudio ) { fmActivity = previousFMActivity; }
		
		if ( fmActivity.attribute && fmActivity.attribute[10] && fmActivity.attribute[10].attrValue != null && fmActivity.attribute[10].attrValue != '' )
			{
				if ( !this.state.pauseActivityOnStart )
					{
						var id = parseInt(fmActivity.attribute[10].attrValue);
						console.log('ID PLAY---', id);
						if ( id > 0 ) 
							{ this.playPlayer(fmActivity.attribute[10].attrValue, fmActivity.attribute[11].attrValue); }
						else 
							{ this.stopPlayer(); }
					}
			}
	});
	
	let addObject = {"sessionId": this.state.currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": this.state.currentUserData.id, "toFromId": "all", "message": 214, "details": JSON.stringify({"action":"next", "type":"script", "name": currentActivity.name, "scriptIndex": currentNum}), "timestamp": Util.getCurrentTimestamp()};
	this.sessionDataStore.addSessionData(addObject);
}

stopScriptAtEnd = () =>{
	this.setState({
		scriptEnded: true,
		minsD2C: 0,
		secD2C: '00',
	});
	if ( this.props && this.props.updateStateFromScript )
		{
			this.props.updateStateFromScript({showBigClock: false});
		}
	this.clearInjectedVideo();
	window.hostStopFitnessScript(1);
	window.$Any('#virtualmsg').addClass('d-none').text('');
	this.stopPlayer();
	window.$Any('.one_activity_menu').addClass('active');
	window.activityAlreadyStarted = false;
	window['script_is_started'] = false;
	window['usingPose'] = false;
	this.stopScriptVirtual();
	var mainthis = this;
	clearTimeout(mainthis.activityWaitTimeout);
	if ( window['userWhiteboard'][this.state.currentUserData.id] && window['userWhiteboard'][this.state.currentUserData.id].trackerActions.mediaPipeToggleTimeout )
		{
			clearTimeout(window['userWhiteboard'][this.state.currentUserData.id].trackerActions.mediaPipeToggleTimeout);
			window['userWhiteboard'][this.state.currentUserData.id].clearMessageInstructions();
			if ( window.disableCalculatingAR ) { window.disableCalculatingAR(); }
		}
} 
 
 
stopFitnessScript = () =>{
	this.setState({
		currentAct: [],
		currentActNum: 0,
		currentActNumWithoutPause: 0,
		currentActivityDuration: 0,
		isPausedActivity: false,
		repsCurrentActiveNum: 0,
		timeInSecLeft: 0,
		repsLeftAfterPause: 0,
		activityStarted: false,
		repsScriptActive: false,
		scriptPaused: false,
		scriptEnded: false,
	}, () => {
		window['currentActNum'] = this.state.currentActNum;
		window['currentActivity'] = this.state.currentAct;
		window['scriptPaused'] = this.state.scriptPaused;
		window['activityStarted'] = this.state.activityStarted;
		if ( this.props && this.props.updateStateFromScript )
			{
				this.props.updateStateFromScript({scriptPaused: this.state.scriptPaused, showBigClock: false});
			}
		window.$Any('#virtualmsg').addClass('d-none').text('');
		window['repsScriptActive'] = this.state.repsScriptActive;
		this.clearInjectedVideo();
		this.soundPlay.stopAudio();	
		window['script_is_started'] = false;
		$('#startWork').removeClass('d-none');
		
		if ( window['stopScriptD2C'] )
			{
				window['stopScriptD2C']();
			}
	});

	$('#mainDurationSvg').attr({'style': '--progress-bar-width:6px;--progress-color:#121126;--progress-percent: 0;'});
	
	if ( !this.props.state.multi_window_status )
		{
			$('.hold_script').css({'left': "0px"});
		}
	else 
		{
			$('.scriptScrollHolderD2C').css({'left': "0px"});
		}		
	
	window['script_is_started'] = false;
	clearInterval(window['HostMainInterval']);
	window.hostStopFitnessScript(0);
	// window.hostSyncScriptFunction(3, 0, 0, 0); -- asked by Vaibhav
	window.$Any('.one_activity_menu').removeClass('active');
	window.activityAlreadyStarted = false;
	
	this.stopPlayer();
	window['sendMessageToChannel']("feedFm"+this.state.sep+"stop");
	this.stopScriptVirtual();
	window['usingPose'] = false;
	
	if ( window['lastSecTimeOut'] )
		{
			clearTimeout(window['lastSecTimeOut']);
		}
	var mainthis = this;
	clearTimeout(mainthis.activityWaitTimeout);
	let addObject = {"sessionId": this.state.currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": this.state.currentUserData.id, "toFromId": "all", "message": 212, "details": JSON.stringify({"action":"stop", "type":"script"}), "timestamp": Util.getCurrentTimestamp()};
	this.sessionDataStore.addSessionData(addObject);
	if ( window['userWhiteboard'][this.state.currentUserData.id] && window['userWhiteboard'][this.state.currentUserData.id].trackerActions.mediaPipeToggleTimeout )
		{
			clearTimeout(window['userWhiteboard'][this.state.currentUserData.id].trackerActions.mediaPipeToggleTimeout);
			window['userWhiteboard'][this.state.currentUserData.id].clearMessageInstructions();
			if ( window.disableCalculatingAR ) { window.disableCalculatingAR(); }
		}
}

pauseFitnessScript = () =>{
	
	if (this.state.scriptEnded)
		{
			return false;
		}
		
	if ( window['HostMainInterval'] )
		{
			clearInterval(window['HostMainInterval']);
		}
	this.setState({
		scriptPaused: true,
	},()=>{
		this.soundPlay.stopAudio();	
		window['scriptPaused'] = this.state.scriptPaused; 
		if ( this.props && this.props.updateStateFromScript )
			{
				this.props.updateStateFromScript({scriptPaused: this.state.scriptPaused, showBigClock: false});
			}
		});
	
	let currentActNum = this.state.currentActNum;
	let currentActNumWithoutPause = this.state.currentActNumWithoutPause;
	let currentActivity = this.state.currentAct;
	let currentActivityDuration = 0;
	
	if ( currentActivity && currentActivity['attribute'][0]['attrValue'] != 'Pause' && currentActivity['attribute'][0]['attrValue'] != 'Pause Virtual' )
		{
			window.hostPauseFitnessScript();
		}else{
		    window.hostPauseFitnessScript(true);
		}

	if (!this.state.repsScriptActive)
		{
			currentActivityDuration = parseInt(currentActivity['attribute'][2]['attrValue']);
		}
		
	else 
		{
			currentActivityDuration = parseInt(currentActivity.attribute[3].attrValue) * parseInt(currentActivity.attribute[9].attrValue);
		}		
	
	let timeLeft = this.state.timeInSecLeft;
	let timeSpent = currentActivityDuration - timeLeft;
	
	
	var videoInj = window.$Any('#host_injected_video video')[0];
	if ( videoInj )
		{
			videoInj.pause();
		}
	
	//this.stopPlayer();
	
	if ( currentActivity['attribute'][0]['attrValue'] != 'Pause' && currentActivity['attribute'][0]['attrValue'] != 'Pause Virtual' )
		{
			window.hostSyncScriptFunction(2, currentActNum, currentActivityDuration, timeSpent);
		}
		
	let addObject = {"sessionId": this.state.currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": this.state.currentUserData.id, "toFromId": "all", "message": 213, "details": JSON.stringify({"action":"paused", "type":"script", "name": currentActivity.name, "scriptIndex": parseInt(currentActNum+1), "timeRemaining": parseInt(timeLeft)}), "timestamp": Util.getCurrentTimestamp()};
	this.sessionDataStore.addSessionData(addObject);
} 

resumeFitnessScript = () =>{
	
	if ( this.state.scriptEnded )
		{
			return false;
		}
		
	if ( this.state.manualAutomaticScript == 0 && this.state.timeInSecLeft == 0 )
		{
			return false;
		}
	else 
		{
			if ( this.state.manualAutomaticScript == 0 && !this.state.scriptPaused)
				{
					this.skipActivity();
				}
			else 
				{
					this.setState({
						scriptPaused: false,
					}, ()=>{
						if ( this.props && this.props.updateStateFromScript )
							{
								this.props.updateStateFromScript({scriptPaused: this.state.scriptPaused});
							}
					});
					window.scriptPaused = false;
					this.currentActivityDurationNum(this.state.timeInSecLeft);	
					
					window.$Any('#actStart').addClass('d-none');
					
					let addObject = {"sessionId": this.state.currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": this.state.currentUserData.id, "toFromId": "all", "message": 404, "details": JSON.stringify({"action":"started", "type":"script", "name": this.state.currentAct.name, "scriptIndex": 1}), "timestamp": Util.getCurrentTimestamp()};
					this.sessionDataStore.addSessionData(addObject);
					
					if ( this.state.currentAct['attribute'][0]['attrValue'] != 'Pause' && this.state.currentAct['attribute'][0]['attrValue'] != 'Pause Virtual' ) 
						{ 
							window.startHostFitnessScript(); 
						}else{
						    window.startHostFitnessScript(true); 
						}
				}		
			var videoInj = window.$Any('#host_injected_video video')[0];
			console.log('videoInj', videoInj);
			if ( videoInj )
				{
					videoInj.play();
				}
			
			var fmActivity = this.state.currentAct;
			var previousFMActivity = this.findLastFeedFMActivity(this.state.currentActNum);
			if ( previousFMActivity != '' && !this.playerFunctions.isPlayedAudio ) { fmActivity = previousFMActivity; }
				
			if ( fmActivity.attribute && fmActivity.attribute[10] && fmActivity.attribute[10].attrValue != null && fmActivity.attribute[10].attrValue != '' )
				{
					var id = parseInt(fmActivity.attribute[10].attrValue);
					console.log('ID PLAY---', id);
					if ( id && id != NaN )
						{
							if ( id > 0 ) { this.playPlayer(fmActivity.attribute[10].attrValue, fmActivity.attribute[11].attrValue); }
							else { this.stopPlayer(); }
						}
				}
		}
}

startVirtualClass = (mod, pauseAct) =>{
	this.setState({
		scriptPaused: false,
	},()=>{
		if ( this.props && this.props.updateStateFromScript )
			{
				this.props.updateStateFromScript({scriptPaused: this.state.scriptPaused});
			}
	});
	window.scriptPaused = false;
	
	if ( window['userWhiteboard'][this.state.userData.id] )
		{
			window['userWhiteboard'][this.state.userData.id].doActivityEvents('activityStarting');
		}
		
	if ( !pauseAct )
		{
			window.startHostFitnessScript();
		}
	
	this.currentActivityDurationNum(this.state.timeInSecLeft, true);
}

skipActivity = () =>{
	clearTimeout(window['lastSecTimeOut']);
	
	if ( this.state.currentActNum > (this.state.sessionScript.length - 1) )  { return false; }
	
	if ( this.state.manualAutomaticScript == 0 )
		{
			this.setState({
				repsScriptActive: false,
				scriptPaused: false
			}, ()=>{
					clearInterval(window['HostMainInterval']);
					this.startNextScript();
					window['repsScriptActive'] = this.state.repsScriptActive;
					window.scriptPaused = false;
					if ( this.props && this.props.updateStateFromScript )
						{
							this.props.updateStateFromScript({scriptPaused: this.state.scriptPaused});
						}
				});
			
		}
	else
		{
			window.hostSyncScriptFunction();
		}		
	
}
 

setPercent=(fullTime, currentTime)=>{
	var percent = (parseInt(currentTime) / parseInt(fullTime)) * 92;
	var percentWidth = (92 - percent);
	window.$Any('#mainDurationSvg').attr({'style': '--progress-bar-width:6px;--progress-color:#121126;--progress-percent: '+percentWidth+';'}); 
	}

showSkipMessage=()=>{
	if ( this.state.manualAutomaticScript != 0 )
		{
			window.$Any("#skipMsg").css({"display" : "block"});
		}
}	

hideSkipMessage=()=>{
	window.$Any("#skipMsg").css({"display" : "none"});
}

checkIfInjected=()=>{
	if ( !this.props.state.multi_window_status )
		{
			let currentActivity = this.state.currentAct;
			if ( currentActivity.attribute[4] && currentActivity.attribute[4].attrValue != '' )
				{
					let injVideoTime = currentActivity.attribute[8].attrValue;
					var video = window.$Any('#host_injected_video video')[0];
					video.src = currentActivity.attribute[4].attrValue;
					let mainthis = this;
					video.oncanplay = function (){
							video.play();
							window.$Any('#host_video').addClass('d-none');
							window.$Any('#host_injected_video').removeClass('d-none');
							window.$Any('#my_view').addClass('d-none');
							window['InjectedVideoStarted'] = true;
							mainthis.props.updateStateFromChild({InjectedVideoStarted: true});
							if ( window['checkIfCanvasOn'] )
								{
									window['checkIfCanvasOn']();
								}
						}
					
					video.onended = function(e){
						if ( currentActivity.attribute[7] && parseInt(currentActivity.attribute[7].attrValue) == 1 )
								{
									video.play();
								}
							else 
								{
									mainthis.clearInjectedVideo();
								}
					}	
					
					
				}
			else
				{
					this.clearInjectedVideo();
				}
		}
}

clearInjectedVideo=()=>{
	window['InjectedVideoStarted'] = false;
	this.props.updateStateFromChild({InjectedVideoStarted: false});
	window.$Any('#host_video').removeClass('d-none');
	window.$Any('#host_injected_video').addClass('d-none');
	window.$Any('#my_view').removeClass('d-none');
	
	var videoInj = window.$Any('#host_injected_video video')[0];
	if ( videoInj )
		{
			videoInj.pause();
			videoInj.src = '';
		};
}

openCloseActivities=()=>{
	var activityListOpenVar = this.props.activityListOpen;
	if ( !activityListOpenVar ) 
		{
			this.props.updateStateFromChild({rightMenuOpen: true, activityListOpen: true, chatOpen: false});
		}
	else
		{
			this.props.updateStateFromChild({rightMenuOpen: false, activityListOpen: false, chatOpen: false});
		}
}

sendSyncWhenPartJoin=()=>{
	
	if ( this.state.activityStarted )
		{
			let state = 1;
			if ( this.state.scriptPaused )
				{
					state = 2;
				}
			let currentActNum = this.state.currentActNum;
			let currentActNumWithoutPause = this.state.currentActNumWithoutPause;
			let currentActivity = this.state.currentAct;
			let currentActivityDuration = 0;
			
			if (!this.state.repsScriptActive)
				{
					currentActivityDuration = parseInt(currentActivity['attribute'][2]['attrValue']);
				}
				
			else 
				{
					currentActivityDuration = parseInt(currentActivity.attribute[3].attrValue) * parseInt(currentActivity.attribute[9].attrValue);
				}		
			let timeLeft = this.state.timeInSecLeft;
			let timeSpent = currentActivityDuration - timeLeft;	
			
			if ( this.state.currentAct['attribute'][0]['attrValue'] != 'Pause' && this.state.currentAct['attribute'][0]['attrValue'] != 'Pause Virtual' ) 
				{ 
					window.hostSyncScriptFunction(state, currentActNum, currentActivityDuration, timeSpent, this.state.scriptEnded);
					
				}
			else 
				{
					window.sendSyncWhenPartJoinOnPause(currentActNum);
				}				
		}
}

addVirtualEquipment = (currentActivity, pauseActivityType, previousPause) => {
	if ( !window['userWhiteboard'] ) { window['userWhiteboard'] = {}; }
	var pauseAct = false;
	var pauseVirtual = false;
	var mainthis = this;
	
	if ( pauseActivityType )
		{
			if ( pauseActivityType['attribute'][0]['attrValue'] == 'Pause Virtual' ) { pauseVirtual = true; this.setState({stopPauseVirtual: true}); }
			else if ( pauseActivityType['attribute'][0]['attrValue'] == 'Pause' ) { pauseAct = true; }
		}
	
	if ( !pauseAct ) { window['currentActivity'] = currentActivity; }
	let script_name = currentActivity['name'];
	
	var countDown = window['timeLefSec'];
	console.log('start virtual script_name', script_name);
	window.$Any('#actStart').html('Start '+script_name);
	window.$Any('.closePalette').trigger('click');
	
	setTimeout(function(){
		window.$Any('.participantStreamPart').each(function(item, index){
			 let parIdMain = window.$Any(this).attr('id').split('participant_agora');
			 let parId = parseInt(parIdMain[1]);
			  if ( parId != window.currentUserData['id'] )
				{
					var roomSetupDone = true;
					
					if ( !window['userWhiteboard'][parId] ) { roomSetupDone = false; }
					
					if ( window['userWhiteboard'][parId] && !window['userWhiteboard'][parId].roomSetup.viewCaptured ) 
						{ 
							window['userWhiteboard'][parId].mouseActions.paletteClearClick();
							roomSetupDone = false;
						}
					
					if ( roomSetupDone )
						{
							if ( !pauseVirtual )
								{
									window['userWhiteboard'][parId].activityStarted(script_name);
									window['userWhiteboard'][parId].currentActivityName = script_name;
									window.$Any('#canvasWrap'+parId).removeClass('d-none');
									if ( window.currentUserData.sessionData.manualAutomaticScript != 1 ) { window.$Any('#actStart').removeClass('d-none'); }
								}
							else
								{
									window.$Any('#canvasWrap'+parId).addClass('d-none');
									window.changeGlobalActType('', parseInt(parId));
								}
						}
				}
		  });
	}, 500);
	
	/* if ( window['userWhiteboard'][this.state.userData.id] )
		{
			window['userWhiteboard'][this.state.userData.id].currentActivityName = script_name;
			
			if ( !window['userWhiteboard'][this.state.userData.id].roomSetup.viewCaptured ) 
				{ 
					window['userWhiteboard'][this.state.userData.id].mouseActions.paletteClearClick();
					window.startRoomSetup();
					return false; 
				}
			else
				{
					window['userWhiteboard'][this.state.userData.id].activityStarted(script_name);
					setTimeout(function() { $('#canvasWrap').removeClass('d-none'); }, 2000);
				}
		} */
		
	var currentNum = this.state.currentActNum;
	let nextActivity = this.state.sessionScript[currentNum];
	console.log('script_name');
	console.log(script_name);
	console.log('nextActivity');
	console.log(nextActivity);
	if ( this.state.userData.default.hostVirtual == 1 && this.state.userData.isMarketplaceChannel == 1 )
		{
			if ( !window['userWhiteboard'][this.state.userData.id] )
				{
					console.log('LOADED SCRIPT',this.state.userData.id);
					
					window['userWhiteboard'][this.state.userData.id] = new whiteboard({'user_id': this.state.userData.id, 'host_virtual': true});
					setTimeout(function() { $('#canvasWrap').removeClass('d-none'); }, 2000);
				}
			else
				{
					var useAct = currentActivity;
					
					window['userWhiteboard'][this.state.userData.id].currentActivityName = useAct['name'];
			
					if ( !window['userWhiteboard'][this.state.userData.id].roomSetup.viewCaptured ) 
						{ 
							window['userWhiteboard'][this.state.userData.id].mouseActions.paletteClearClick();
							window.startRoomSetup();
							return false; 
						}
					else
						{
							console.log('activityStarted useAct');
							console.log(useAct);
							if ( window['userWhiteboard'][this.state.userData.id].trackerActions.turnOffMediaPipe ) 
								{ 
									setTimeout(function() { window['userWhiteboard'][mainthis.state.userData.id].trackerActions.toggleMediaPipe(false); }, 1000);
								}
							window['userWhiteboard'][this.state.userData.id].activityStarted(useAct['name']);
							$('#canvasWrap').removeClass('d-none');
							if ( window.detectionDisabled ) { window.$Any('#virtualmsg').text('Device Not Supported').removeClass('d-none'); }
						}
				}
		}
	
	if ( !pauseAct && !pauseVirtual ) { this.setState({pauseActivityOnStart: true}); }
	//else if ( pauseAct ) { window['sendMessageToChannel']("pauseActivityStarted"+this.state.sep+script_name); }
	//else if ( pauseVirtual ) { window['sendMessageToChannel']("pauseVirtualActivityStarted"+this.state.sep+script_name); }
}

checkRoomSetup = () => {
	if ( !window['userWhiteboard'] ) { window['userWhiteboard'] = {}; }
	var mainthis = this;
	window.$Any('.participantStreamPart').each(function(item, index){
		let parIdMain = window.$Any(this).attr('id').split('participant_agora');
		let parId = parseInt(parIdMain[1]);
		if ( ( window['hasConeScript'] ) || ( !window['hasConeScript'] && JSON.parse(localStorage.getItem('hostSettings')).calculateAssessmentDimensions == 1 ) )
			{
				if ( parId != mainthis.state.userData['id'] && (!window['userWhiteboard'][parId] || (window['userWhiteboard'][parId] && !window['userWhiteboard'][parId].roomSetup.viewCaptured)) )
					{
						if ( window['deviceNotSupported'+parId] )
							{
								setTimeout(function(){
									if ( mainthis.state.scriptPaused ) { window.$Any('#virtualmsg-'+parId).text('Device Not Supported').removeClass('d-none'); }
								}, 1000);
							}
						else
							{
								window['participantDetails'] = window.collection.getDetailsById(parId);
								//mainthis.setState({pauseActivityOnStart: true});
								window['firstActSetup'+parId] = true;
								window['startDrawing'](false, parId);
								window.showNextActFirst = true;
								window['injectedVideoPause'] = true;
								var canvasSize = {};
								canvasSize['w'] = window.$Any('#sessionCanvas'+parId)[0].width;
								canvasSize['h'] = window.$Any('#sessionCanvas'+parId)[0].height;
								var email = window['participantDetails']['email'];
								console.log('ROOM INNIT');
								let sep = '~@$';
								let canvasLinesArr = window['canvasLines'+parId] ? window['canvasLines'+parId] : [];
								window['globalRTM'](email, 'draw'+sep+JSON.stringify(canvasLinesArr)+'cSize'+JSON.stringify(canvasSize)+sep+'roomSetup');
							}
					}
			}
	});
}

stopScriptVirtual = () => {
	if ( window['canvasOn'] )
		{
			window.$Any('.canvas-close-icon').trigger('click');
		}
	
	window.$Any('.participantStreamPart').each(function(item, index){
		let parIdMain = window.$Any(this).attr('id').split('participant_agora');
		let parId = parseInt(parIdMain[1]);
		
		if ( !window['userWhiteboard'][parId] ) { return false; }
		
		window.$Any('#virtualmsg-'+parId).text('').addClass('d-none');
		window.$Any('#repCount'+parId).html(0);
		window.$Any('#canvasClearLines'+parId).removeClass('d-none');
		window.$Any('#canvasClear'+parId).removeClass('d-none');
		window.$Any('#setupEquipmentHold'+parId).removeClass('whiteBkg');
		window.$Any('.palette-dropdown').prop('disabled', false);
		window.$Any('.equipment_stats_hold').addClass('d-none');
		
		window['userWhiteboard'][parId].globalActType = '';
		window['roomSetupRunning'+parId] = false;
		window['showTargetCircle'+parId] = true;
		window['showTargetCircleRight'+parId] = false;
		window['showTargetCircleMiddle'+parId] = false;
		window.changeGlobalActType('', parseInt(parId));
	});
	
	if ( window['userWhiteboard'] && window['userWhiteboard'][this.state.userData.id] )
		{
			$('#canvasWrap').addClass('d-none');
			window.changeGlobalActType('', parseInt(this.state.userData.id));
			window.$Any('#virtualmsg').addClass('d-none').text('');
		}
}

playPlayer=(id, name)=>{
	let mainthis = this;
	this.playerFunctions.stopPlayer();
	setTimeout( function(){
		mainthis.playerFunctions.playPlayer(id, name);
		if ( window['showPlayer'] ){ window['showPlayer'](true); }
	}, 1);
	
	window['sendMessageToChannel']("feedFm"+this.state.sep+"play"+this.state.sep+id+this.state.sep+name);
	window['currentFmStation'] = id;
	window['currentFmName'] = name;
	this.lastFMCheck = new Date().getTime();
}

stopPlayer=()=>{
	this.playerFunctions.stopPlayer();
	window['sendMessageToChannel']("feedFm"+this.state.sep+"stop");
	if ( window['showPlayer'] ){ window['showPlayer'](false); }
	window['currentFmStation'] = "";
	window['currentFmName'] = "";
}

showVolume=(mod)=>{
	this.setState({isPlayingFm: mod})
}

changeVolumeFm=(e, mod)=>{
	if ( !mod )
		{
			this.setState({[e.target.id]: e.target.value});
			this.playerFunctions.changeVolume(e.target.value);
		}
	else 
		{
			this.setState({volumeFM: mod});
			this.playerFunctions.changeVolume(mod);
		}		
}

nextTutorial=(mod, ev)=>{
	ev.preventDefault();
	ev.stopPropagation();
	this.props.nextTutorial(mod); 
}

backTutorial=(mod, ev)=>{
	ev.preventDefault();
	ev.stopPropagation();
	this.props.backTutorial(mod);
}

showToolTip=(num, mod)=>{
		this.setState({
			toolTipText: mod,
			toolTipMsg: num,
		});
}

	nextTutorial=(mod, ev)=>{
		ev.preventDefault();
		ev.stopPropagation();
		this.props.nextTutorial(mod); 
	}
	
	backTutorial=(mod, ev)=>{
		ev.preventDefault();
		ev.stopPropagation();
		this.props.backTutorial(mod);
	}
	
hideToolTip=()=>{
	this.setState({
		toolTipText: '',
		toolTipMsg: 0,
	});
}

  render() {
    return (
		<div className="workout">
			{ !this.props.state.multi_window_status && 
				<div>
					{ this.state.sessionScript && this.state.sessionScript.length > 0 &&
						<div className="test-script host_fitness_script h-100 position-relative">
							<div className="overflow-hidden h-100">
								<div className="script-info h-100 poppinsFont">
									<div className="activityCurrentPlayerHolder" >
										<div className="myvideo_title" >Activities ({this.state.currentActNum}/{this.state.sessionScript.length}) 
											<span className="viewAllSpan" onClick={this.openCloseActivities} id="view_all_activities">View all</span> 
											{this.props.state.tutorialMessNum == 4 &&
											<InstructorTutorial
												nextTutorial={this.nextTutorial}
												backTutorial={this.backTutorial}
												state={this.state}>
											</InstructorTutorial>
											}
										</div>
											{ (( this.state.activityStarted && this.props.state.sessionStartedByHost ) || this.props.state.tutorialMessNum == 6 ) &&
												<div>
													<div className="currentActHolder" data-index={this.state.currentActNum}>
														<div className={classnames("div_svg_background " + (this.state.scriptPaused? "pausedBackgroundColor" : "" ))} ></div>								
														<svg className="workout_svg_host" id="mainDurationSvg" data-role="radial-progress" viewport="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
															<circle r="38.5" cx="41" cy="41" fill="transparent"></circle>
														</svg>
														{this.state.scriptPaused&&
															<div>
																{this.state.currentActivityDuration != '00:00' ? 
																	<div className="actPauseText" >Activity paused</div>
																	:
																	<div className="actPauseText" >Activity ended</div>
																}
															</div>
														}
														<div className="actNameHolder" >
															<div className="currentActivityNameHolder" >
																{this.props.state.tutorialMessNum == 6 ?
																	<div className="holder_name_activity" >Bodyweight Squats</div>
																	:
																	<div className="holder_name_activity" >{this.state.currentAct['name']}</div>
																}
															</div>
														</div>
														{this.props.state.tutorialMessNum == 6 ?
														<div className="counterScriptNew" id="#currentActivityDuration" >
															<div className="timerHold" >10</div>
														</div>
														:
														<div className="counterScriptNew" id="#currentActivityDuration" >
															{this.state.repsScriptActive &&
																<div className="repsNum" >{this.state.repsCurrentActiveNum}</div>
															}
															<div className="timerHold" >{this.state.currentActivityDuration}</div>
														</div>
														}
													</div>
													<div className="currentActHolder playerPadding" >
														<div className={classnames("playerOptionsHolder " + (this.state.manualAutomaticScript != 0 ? "halfOptionsHolders" : "" ))} >
															<div className="btnHolderClicks" onClick={this.stopFitnessScript} id="stopButtonClick">	
																<div className="playOptionBtn" ></div>
																<div className="playerOptionText" >Stop</div>
															</div>
														</div>
														
														<div className={classnames("playerOptionsHolder " + (this.state.manualAutomaticScript == 0 ? "bordersMiddleHolder " : "" ) + (this.state.manualAutomaticScript != 0 ? "halfOptionsHolders " : "" ) + (this.state.scriptEnded ? "scriptEndedDiv " : "" ))} >													
																{!this.state.scriptPaused ? 
																	<div className="btnHolderClicks" onClick={this.pauseFitnessScript} id="pauseButtonClick">
																		<div className="playOptionBtn pauseBtnHost" ></div>
																		<div className="playerOptionText" >Pause</div>
																	</div>
																	:
																	<div className="btnHolderClicks" onClick={this.resumeFitnessScript} id="resumeButtonClick">
																		<div className="playOptionBtn playBtnHost" ></div>
																		<div className="playerOptionText" >Resume</div>
																	</div>
																}
														</div>
														{this.state.manualAutomaticScript == 0 &&
															<div className={classnames("playerOptionsHolder " + (this.state.scriptEnded ? "scriptEndedDiv " : "" ) + (this.state.currentActNum >= this.state.sessionScript.length ? "scriptEndedDiv " : "" ) )} >
																<div className="skipMsg" id="skipMsg">Next is not available in automatic script</div>
																<div className="btnHolderClicks" onClick={this.skipActivity}  onMouseOver={this.showSkipMessage} onMouseLeave={this.hideSkipMessage}>											
																		<div className="playOptionBtn skipBtnHost" ></div>
																		<div className="playerOptionText" >Next</div>	
																</div>
															</div>
														}
														{this.props.state.tutorialMessNum == 6 &&
															<InstructorTutorial
															nextTutorial={this.nextTutorial}
															backTutorial={this.backTutorial}
															state={this.state}>
															</InstructorTutorial>
														}
													</div>
												</div>
											}
											{ (( !this.state.activityStarted && this.props.state.sessionStartedByHost ) || this.props.state.tutorialMessNum == 5 ) &&
												<div className="currentActHolder startActivityHolderAll">
													<div className="startActButtonHolder" >
														<div className="startActBtn" id="start_new_activity" onClick={this.fitnessScriptStart}>Start activities</div>
													</div>
													{this.props.state.tutorialMessNum == 5 &&
														<InstructorTutorial
														nextTutorial={this.nextTutorial}
														backTutorial={this.backTutorial}
														state={this.state}>
														</InstructorTutorial>
													}										
												</div>
											}
									</div>
								
									<div className="holdAllActs" className={classnames("holdAllActs " + (this.props.state.sessionStartedByHost ? "holdAllActsWithPlayer" : "" ) + (this.props.state.tutorialMessNum == 5 || this.props.state.tutorialMessNum == 6 ? "holdAllActsWithPlayer" : "" ) )} >
										<div className="hold_script"  style={{width: this.state.sliderWidth}} >
											{ this.state.sessionScript && this.state.sessionScript.map((item, i)=>
												<div className={classnames("upNextActivityHolder " + (i == this.state.currentActNum ? "upNextHolder" : "" ))} key={i} id={"currentAct"+i} style={{width: this.props.state.oneActWidth}} >
													<div className="holdPadding" >	
														{i == this.state.currentActNum &&
															<div className="upNextText" >UP NEXT</div>
														}
														<div className={classnames("upNextActivityName " + (i < this.state.currentActNum ? "pastHolder" : "" ))} >{item.name}</div>
														{item.attribute[1]['attrValue'] == 'Time' &&
															<div className="upNextActivityTime" >{item.attribute[2].attrValue} sec</div>
														}
														{item.attribute[1]['attrValue'] == 'Reps' &&
															<div className="upNextActivityTime" >0/{item.attribute[2].attrValue} reps</div>
														}
													</div>
												</div>
											)}
										</div>	
									</div>	
								</div>
							</div>
						</div>
					}
					{ this.state.sessionScript && this.state.sessionScript.length === 0 &&
						<div className="empty_script">No Workout Script.</div>
					}
				</div>
			}
			{this.props.state.multi_window_status &&
				<div>
					{ this.state.sessionScript && this.state.sessionScript.length > 0 &&
						<div className="scriptHolderMainD2C">
							<div className="scrollMainHolderD2C" >
								<div className="scriptScrollHolderD2C" style={{width: this.state.D2CSliderWidth}} >
									{ this.state.sessionScript && this.state.sessionScript.map((item, i)=>
										<div className="activityHolderD2C" className={classnames("activityHolderD2C " + (i == ( this.state.currentActNum - 1 ) && this.state.scriptEnded == false ? "activeActivityD2C" : "" ))} style={{width: this.state.oneD2CActWidth}} key={i} id={"currentAct"+i}>
											<div className="innerHolderActivityD2C" >	
												<div className="innerHolderAbs" >
													{item.attribute[1]['attrValue'] == 'Time' && 
														<div className="durationHolderD2C" >											
															{ ( this.state.currentActNum - 1 ) == i ?													
																	<div className="minutesD2C" >{this.state.minsD2C}:{this.state.secD2C}</div>												
																:											
																<div className="minutesD2C" >{this.getInactiveMin(item.attribute[2].attrValue)}:{this.getInactiveSec(item.attribute[2].attrValue)}</div>													
															}
														</div>
													}
													{item.attribute[1]['attrValue'] == 'Reps' && 
														<div className="durationHolderD2C" >											
															{ ( this.state.currentActNum - 1 ) == i ?
																<div>
																	<div className="minutesD2C" >{this.state.repsCurrentActiveNum}</div>
																	<div className="secD2C" >{this.state.secD2CReps}</div>
																</div>
																:
																<div>
																	<div className="minutesD2C" >{item.attribute[2].attrValue}</div>
																	<div className="secD2C" >{this.getInactiveSecReps(item)}</div>
																</div>
															}
														</div>
													}											
													<div className={"activityTextD2C " + ( (item.name.length > 20 || (item.name.split(' ').length > 2 && item.name.length > 14)) ? 'fnt47' : '')}>
														{ item.attribute[12] && item.attribute[12].attrValue && item.attribute[12].attrValue !== '' ? 
															item.attribute[12].attrValue
															:
															item.name
														}
														{item.attribute[0]['attrValue'] == "Pause Virtual" && 
															<sup>P</sup> 
														}
													</div>
												</div>
												<div className="activityCounterD2C" onClick={this.openCloseActivities}>{i+1}/{this.state.sessionScript.length}</div>
											</div>	
										</div>
									)}
								</div>
							</div>
							<div className="d-none">
									<div className="btnHolderClicks" onClick={this.stopFitnessScript} id="stopButtonClick">	
										<div className="playOptionBtn" ></div>
										<div className="playerOptionText" >Stop</div>
									</div>
							
									{ !this.state.scriptPaused ? 
										<div className="btnHolderClicks" onClick={this.pauseFitnessScript} id="pauseButtonClick">
											<div className="playOptionBtn pauseBtnHost" ></div>
											<div className="playerOptionText" >Pause</div>
										</div>
										:
										<div className="btnHolderClicks" onClick={this.resumeFitnessScript} id="resumeButtonClick">
											<div className="playOptionBtn playBtnHost" ></div>
											<div className="playerOptionText">Resume</div>
										</div>
									}
									
									<div className="startActBtn" id="start_new_activity" onClick={this.fitnessScriptStart}>Start activities</div>
							</div>
						</div>
					}
					{ this.state.sessionScript && this.state.sessionScript.length === 0 &&
						<div className="empty_script">No Workout Script.</div>
					}
				</div>
			}
		</div>
	);
  }

	notifyActivityChange(isEnded, currentActivity = '') {
		if (isEnded) {
			if (this.state.currentActNum === this.state.currentAct.length || this.state.currentActNum === this.state.sessionScript.length) {
									this.props.updateStateFromChild({Notes_CurrentActivity : {id:'activity_1',payload:'',type:'activity'}})
			}
		} else {
			if ( this.state.currentActNum !== "" &&  this.props.state && this.props.state.sessionData.sessionActivity && this.props.state.sessionData.sessionActivity[this.state.currentActNum] )
				{
					let activity = this.props.state.sessionData.sessionActivity[this.state.currentActNum];
					this.props.updateStateFromChild({
						Notes_CurrentActivity: {
							id: `activity_${activity.sessionScriptId}`,
							payload: activity.ActivityNotes,
							type: 'activity'
						}
					})
				}
		}
	}
}
export default connect(
  null,
  {},
  null,
  {forwardRef: true}
)(HostFitnessScript); 